import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

import TextField from 'material-ui/TextField';
import ExerciseRepTable from './ExerciseRepTable';
import ExercisePlain from './ExercisePlain';
import ExerciseSelect from './ExerciseSelect';

import * as DesignerState from '../../../../state/reducer/designer/designer';
import * as Utils from '../../../../lib/designerUtils';
import Console from '../../../../lib/debug';

const MAX_EXERCISE_NOTES_LENGTH = 10000;

class ExerciseTable extends PureComponent {
    state = {
        toggle: true,
        instruction: this.props.exercise.instruction || ''
    };

    handleKeyUp = event => {
        if (event.target.value.length > MAX_EXERCISE_NOTES_LENGTH) return;

        this.setState({
            instruction: event.target.value
        });
    };

    onToggle() {
        let force =
            typeof arguments[0] === 'boolean' ? arguments.length > 0 : false;
        let open = arguments[0];
        let toggle = force ? open : !this.state.toggle;
        this.setState(() => ({
            toggle
        }));
    }
    updateInstructions = event => {
        let dispatch = this.props.dispatch;
        let exercise = this.props.exercise;

        DesignerState.updateExerciseValue(
            dispatch,
            exercise,
            'instruction',
            event.target.value
        );
    };
    render() {
        Console.render('designer.ExerciseTable');
        let dispatch = this.props.dispatch;
        let exercise = this.props.exercise;
        let session = this.props.session;
        let block = this.props.block;
        let position = this.props.position;
        let parent = this.props.parent;
        let subtitle = Utils.getBlockTitle(this.props.blockPosition);
        if (block.exerciseKeys.length > 1) {
            subtitle += position;
        }

        let classes =
            exercise.video_url !== ''
                ? 'exercise chips'
                : 'exercise chips hide-grid';

        let exerciseInstructions = (
            <div className="exercise-instructions">
                <span className="th-textarea-label">Exercise Instructions</span>
                <TextField
                    id="exercise-notes"
                    className="th-textarea"
                    multiline
                    fullWidth
                    value={this.state.instruction}
                    onChange={this.handleKeyUp}
                    onBlur={this.updateInstructions}
                    margin="normal"
                    placeholder="Ex. Stay tight. Attack each rep!"
                />
                <span className="character-count">
                    {this.state.instruction.length}/{MAX_EXERCISE_NOTES_LENGTH}
                </span>
            </div>
        );

        return (
            <div className="exercise-table-wrapper">
                <div className="exercise-content opened">
                    <div className="exercise-search">
                        <div className="exercise-subtitle">{subtitle}</div>
                        <ExerciseSelect
                            block={block}
                            onlyExerciseElements={true}
                            exerciseKey={exercise.key}
                            parent={parent}
                            dispatch={dispatch}
                            session={session}
                        />
                        {exerciseInstructions}
                        <div className="block-videos">
                            <div className={classes}>
                                <div className="grid-videos">
                                    <ExercisePlain
                                        exercise={exercise}
                                        block={block}
                                        dispatch={dispatch}
                                        position={position}
                                        hideDelete={true}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="exercise-tables">
                        <ExerciseRepTable
                            ref={component => (this.scheme = component)}
                            block={block}
                            exercise={exercise}
                            session={session}
                            dispatch={dispatch}
                            onToggle={this.onToggle.bind(this)}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

let mapStateToProps = function(state, ownProps) {
    let ex = state.calendar.exerciseTree[ownProps.exercise.key];
    if (ex && state.uiTree.exercises[ex.key]) {
        ex.video_thumbnail = state.uiTree.exercises[ex.key].videoThumbnail;
    }

    return {
        exercise: ex,
        exerciseRef: state.library.exerciseRef,
        ...ownProps
    };
};

export default connect(mapStateToProps)(ExerciseTable);



// WEBPACK FOOTER //
// ./src/view/designer/components/Exercise/ExerciseTable.jsx